"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _variables = _interopRequireDefault(require("./variables"));
var functions = {
  /* PX-to-REM
  /* ----------------------------------- */
  toRem: function toRem(px /*: number*/) /*: string*/{
    return "".concat(px / _variables.default.base, "rem");
  }
};
var _default = exports.default = functions;
//# sourceMappingURL=functions.js.map